<template>
  <div class="categoricaldata">
    <b-loading :active="isLoading" :is-full-page="false"></b-loading>

    <OmxPageHeader
        :title="$t('categories-view.title')"
        :subtitle="$t('categories-view.subtitle')"
        sticky
    >
      <template #actions>
        <b-button @click="backClicked" icon-left="arrow-left">{{ $t('common.back') }}</b-button>
      </template>
    </OmxPageHeader>

    <OmxCard density="compact" class="categoricaldata__tabs-card">
      <b-tabs type="is-toggle" expanded v-model="activeTab" class="categoricaldata__tabs">
        <b-tab-item :label="$t('tasks-view.component-title')" icon="format-list-checks">
          <TasksCategorical
              :categorical_data="categoricalData.tasks"
              @addCategoricalData="showAddNewPrompt"
              @updateCategoricalData="updateCategories"
              @deleteCategoricalData="showDeletePrompt"
          />
        </b-tab-item>
        <b-tab-item :label="$t('personnel-view.component-title')" icon="account-hard-hat">
          <PersonnelCategorical
              :categorical_data="categoricalData.personnel"
              @addCategoricalData="showAddNewPrompt"
              @updateCategoricalData="updateCategories"
              @deleteCategoricalData="showDeletePrompt"
          />
        </b-tab-item>
        <b-tab-item :label="$t('equipments-view.component-title')" icon="robot-industrial">
          <EquipmentsCategorical
              :categorical_data="categoricalData.equipments"
              @addCategoricalData="showAddNewPrompt"
              @updateCategoricalData="updateCategories"
              @deleteCategoricalData="showDeletePrompt"
          />
        </b-tab-item>
        <b-tab-item :label="$t('consumables-view.component-title')" icon="cart-variant">
          <ConsumablesCategorical
              :categorical_data="categoricalData.consumables"
              @addCategoricalData="showAddNewPrompt"
              @updateCategoricalData="updateCategories"
              @deleteCategoricalData="showDeletePrompt"
          />
        </b-tab-item>
      </b-tabs>
    </OmxCard>
  </div>
</template>

<script>
import firebase from "firebase/app";
import TasksCategorical from "@/components/TasksCategorical";
import PersonnelCategorical from "@/components/PersonnelCategorical";
import EquipmentsCategorical from "@/components/EquipmentsCategorical";
import ConsumablesCategorical from "@/components/ConsumablesCategorical";
import OmxPageHeader from "@/components/OmxPageHeader.vue";
import OmxCard from "@/components/OmxCard.vue";

export default {
  name: "CategoricalData",
  components: {
    OmxPageHeader,
    OmxCard,
    TasksCategorical,
    PersonnelCategorical,
    EquipmentsCategorical,
    ConsumablesCategorical
  },
  data() {
    return {
      categoricalData: [],
      isLoading: false,
      activeTab: 0
    };
  },
  methods: {
    readCategoricalData() {
      this.isLoading = true;
      this.categoricalData = [];
      const functions = firebase.app().functions(this.$brand.functionsRegion);
      const getCategoriesFn = functions.httpsCallable(this.getSubmitEndpoint());
      getCategoriesFn({ action: "get_categories", collections: ["tasks", "personnel", "equipments", "consumables"] })
          .then((result) => {
            this.categoricalData = result.data;
            this.isLoading = false;
          })
          .catch((error) => {
            this.showError(this.$t('messages.save-error'));
            console.error("Error reading categories: ", error?.code);
            this.isLoading = false;
          });
    },
    async showAddNewPrompt(onConfirmBlock) {
      const r = await this.$omxPrompt({
        inputAttrs: { type: 'text', placeholder: this.$t('categories-view.enter-name').toString() },
        confirmText: this.$t('common.add').toString()
      });
      if (r === null) return;
      const name = (r.value || "").toString().trim();
      if (!name) {
        this.showError(this.$t('messages.required-fields-error'));
        return;
      }
      onConfirmBlock(name);
    },
    updateCategories(payload) {
      this.isLoading = true;
      const functions = firebase.app().functions(this.$brand.functionsRegion);
      const updateCategoriesFunction = functions.httpsCallable(this.getSubmitEndpoint());
      updateCategoriesFunction({
        action: "update_category",
        collection: payload.collectionName,
        data: { [payload.dataFieldTitle]: payload.data }
      }).then(() => {
        this.isLoading = false;
        const tempCategoricalData = JSON.parse(JSON.stringify(this.categoricalData));
        tempCategoricalData[payload.collectionName][payload.dataFieldTitle] = payload.data;
        this.categoricalData = tempCategoricalData;
        this.showSuccess(this.$t('messages.success'));
      }).catch((error) => {
        this.isLoading = false;
        this.showError(this.$t('messages.save-error'));
        console.error("Error updating category: ", error?.code);
      });
    },
    async showDeletePrompt(onConfirmBlock) {
      const ok = await this.$omxConfirm({
        title: this.$t('categories-view.delete-element-title').toString(),
        message: this.$t('categories-view.delete-element-message').toString(),
        confirmText: this.$t('categories-view.delete-element-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        icon: 'delete'
      });
      if (ok) onConfirmBlock();
    },
    backClicked() {
      this.$router.back();
    }
  },
  mounted() {
    this.readCategoricalData();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.categoricaldata {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.categoricaldata__tabs-card {
  padding: 0 !important;
  overflow: hidden;
  ::v-deep .b-tabs .tabs ul { border-bottom: 1px solid $omx-ink-100; }
  ::v-deep .b-tabs .tab-content { padding: 18px; }
}
</style>
